import { Checkbox, Divider, Row } from "antd";
import Validations from "./DistributionPointValidations";
import tooltipList from "../tooltip.json";
import ResponsiveCol from "../../../../common/components/form/ResponsiveCol";
import { DistributionPointRequestResource, Products } from "api/generated";
import { FormItem } from "common/components/form/FormItem";

interface ProductsDataFormProps {
  products: Products[];
}

function ProductsDataForm({ products }: ProductsDataFormProps) {
  return (
    <div>
      <Divider
        orientation="left"
        style={{ fontSize: "15px", color: "#606676" }}
      >
        Productos
      </Divider>
      <Row>
        <span
          className="instructions"
          style={{ width: "100%", height: "auto" }}
        >
          Selecciona las casillas en donde aparezcan los productos que se
          venderán en la planta
        </span>
      </Row>

      <Row>
        <ResponsiveCol size="xl">
          <FormItem<DistributionPointRequestResource>
            label="Productos a vender"
            name="productsSold"
            rules={Validations.ProductsSoldRules}
            extra={tooltipList.productos}
          >
            <Checkbox.Group
              options={products.map((item) => {
                return {
                  value: item.idProduct ?? 0,
                  label: item.productDescription,
                  disabled: !item.activeProduct,
                };
              })}
            />
          </FormItem>
        </ResponsiveCol>
      </Row>
    </div>
  );
}

export default ProductsDataForm;
